module.exports = __webpack_public_path__ + "static/media/draussen_klein.779a5cf4.jpg";